import React, { useEffect } from 'react';
import './Step.scss';
import { useWizard } from './useWizard';

export interface StepChildRenderProps {
    next: () => void;
    previous: () => void;
    activeStep: any;
}

export type RenderProp = (stepChildProps: StepChildRenderProps) => React.ReactNode;

export interface StepProps {
    id: number | string;
    name: string | JSX.Element;
    children: RenderProp | JSX.Element;
    disabled?: boolean;
    onEnter?: () => void;
    onExit?: () => void;
}

export const Step: React.FC<StepProps> = (props) => {

    const { 
        next, 
        previous, 
        activeStep, 
        registerStep, 
        unregisterStep,
        updateStep 
    } = useWizard();

    const { id, name, disabled } = props;

    useEffect(function setup() {
        registerStep({ eventKey: id, name, onExit: props.onExit, onEnter: props.onEnter });

        return function cleanup() {
            unregisterStep(id);
        }
    }, [id]);

    useEffect(function () {
        updateStep({ eventKey: id, name, disabled });
    }, [id, name, disabled]);

    if (!activeStep || activeStep !== props.id) return null;

    let childrenContent: any;
    if (typeof props.children === 'function') {
        childrenContent = props.children({ next, previous, activeStep });
    } else {
        childrenContent = props.children;
    }
    
    return (
        <div className="wizard-step">
            {childrenContent}
        </div>
    )
}